<template>
    <BreadCrumb :items="breadcrumbItems" />
    <main id="main">
        <ApiGuideFuneralForm/>
    </main>
</template>
<script>
import ApiGuideFuneralForm from '@/components/apiGuide/ApiGuideFuneralForm.vue';
import BreadCrumb from '../layout/navigation/BreadCrumb.vue';

export default {
    data() {
        return {
            breadcrumbItems: [
                { href: "/", text: "홈", isHome: true },
                { href: "#", text: "API 연계가이드" },
            ],
        };
    },
    components: {
        ApiGuideFuneralForm,
        BreadCrumb
    }
}
</script>
<style lang="">
    
</style>